/**
 * Display name for an `icon_key`.
 *
 * LUCIDE'S OWN COMPONENT NAME, PascalCase and unspaced. The design's trigger
 * button reads `LogIn` for `log-in` — not "Log In" and not the raw key — because
 * that is what the icon is called in lucide.dev and in the React package. An
 * admin who wants to look a glyph up has the exact search term.
 *
 * A PURE TRANSFORM, not a lookup table. The previous version hardcoded nine
 * names, which meant every icon added to the registry needed a second edit here
 * or it showed up unnamed. Deriving the name means the thirty-six the picker
 * offers — and anything added later — are all named correctly for free.
 *
 * `null` is not an icon: absent `icon_key` means "use the category default", and
 * the picker shows that choice as "Default".
 */
export const iconLabel = (iconKey) => {
  if (!iconKey) return 'Default';
  return iconKey
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');
};

export default iconLabel;
